import { VENUE_SOURCE } from 'constants/logic';

export const VENUE_SOURCE_DISPLAY_NAME = {
  [VENUE_SOURCE.AIMHARDER]: 'AimHarder',
  [VENUE_SOURCE.ANOTHERSPACE]: null,
  [VENUE_SOURCE.BEAT81]: 'BEAT81',
  [VENUE_SOURCE.BEWE]: 'bewe',
  [VENUE_SOURCE.BIORITMO]: 'BIO RITMO',
  [VENUE_SOURCE.BLOSSOM]: 'Blossom',
  [VENUE_SOURCE.BOOKER]: 'Booker',
  [VENUE_SOURCE.BSPORT]: null,
  [VENUE_SOURCE.CLASSTIVITY]: null,
  [VENUE_SOURCE.CLUBREADY]: 'ClubReady',
  [VENUE_SOURCE.CONTROLPLUS]: null,
  [VENUE_SOURCE.COWFACE]: null,
  [VENUE_SOURCE.CRUNCH]: 'CRUNCH',
  [VENUE_SOURCE.CUREFIT]: 'Cure Fit',
  [VENUE_SOURCE.DIBS]: null,
  [VENUE_SOURCE.DIGME]: null,
  [VENUE_SOURCE.EVERSPORTS]: null,
  [VENUE_SOURCE.EVO]: null,
  [VENUE_SOURCE.FITDEGREE]: 'fitDEGREE',
  [VENUE_SOURCE.FITREPUBLIK]: 'FitRepublik',
  [VENUE_SOURCE.FLYWHEEL]: 'Flywheel',
  [VENUE_SOURCE.FRONTDESK]: 'Pike13',
  [VENUE_SOURCE.GLOFOX]: 'Glofox',
  [VENUE_SOURCE.GOOGLE]: null,
  [VENUE_SOURCE.INFINITO]: 'Infinito',
  [VENUE_SOURCE.LIVEADDRESS]: null,
  [VENUE_SOURCE.MARIANATEK]: 'Mariana Tek',
  [VENUE_SOURCE.MINDBODY]: 'MINDBODY',
  [VENUE_SOURCE.MINDBODYAPI]: 'MINDBODY',
  [VENUE_SOURCE.MINDBODYMANUAL]: 'MINDBODY',
  [VENUE_SOURCE.MSINVENTORY]: null,
  [VENUE_SOURCE.ONEFITSTOP]: 'OneFitStop',
  [VENUE_SOURCE.PUREPILATES]: 'Pure Pilates',
  [VENUE_SOURCE.RIDEREPUBLIC]: 'Ride Republic',
  [VENUE_SOURCE.RITUAL]: 'Ritual',
  [VENUE_SOURCE.SPORTSOLUTION]: null,
  [VENUE_SOURCE.STUDIOREPUBLIK]: 'StudioRepublik',
  [VENUE_SOURCE.TEAMUP]: 'TeamUp',
  [VENUE_SOURCE.TECNOFIT]: null,
  [VENUE_SOURCE.THEASSEMBLY]: 'The Assembly',
  [VENUE_SOURCE.TIMP]: null,
  [VENUE_SOURCE.TONEHOUSE]: 'Tone House',
  [VENUE_SOURCE.VIRTUAGYM]: 'virtuagym',
  [VENUE_SOURCE.WELLNESSLIVING]: 'WellnessLiving',
  [VENUE_SOURCE.YOGAIA]: 'Yogaia',
  [VENUE_SOURCE.YOGAMOVEMENT]: 'Yoga Movement',
  [VENUE_SOURCE.ZINGFIT]: 'Zingfit',
};
